import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { status } from '@bt-react/constants'
import getEnvironment, { Environment, EnvironmentObject } from '@bt-react/libs/getEnvironment'
import { WebcastStatusForVotes } from '@bt-react/components/Votes'

const _environment:EnvironmentObject = getEnvironment(true)

const resolveState = ( state ): WebcastStatusForVotes => {
  switch( state ) {
    case status.UPCOMING:
    case status.T_MINUS_30:
    case status.RESCHEDULED:
      return WebcastStatusForVotes.UPCOMING

    case status.PRE_ROLL_INTERSTITIAL:
    case status.LIVE_ENABLED:
    case status.GOING_LIVE:
      return WebcastStatusForVotes.PENDING

    case status.ENDING_LIVE:
    case status.POST_ROLL_INTERSTITIAL:
    case status.COMPLETE:
    case status.CANCELLED:
      return WebcastStatusForVotes.COMPLETE

    case status.LIVE:
    case status.OVERRUN:
    case status.RESCHEDULED:
    default:
      return WebcastStatusForVotes.LIVE
  }
}

const combineStates = (status, messagingEnabled): WebcastStatusForVotes => {

 if( messagingEnabled && status === WebcastStatusForVotes.UPCOMING ){
    return WebcastStatusForVotes.PENDING
  }
  return status
}

const isLocalHost = (): boolean =>  _environment.env === Environment.localhost
const getLocalStatus = (state: State): WebcastStatusForVotes => state.votes.webcastStatus
const getWebcastStatus = (state: State): WebcastStatusForVotes => resolveState( state.ui.status )
// TODO backend should be returning the T-5 status ... for now the messaging feature tracks if we
//  are within 5 minutes or less of going live so use that to calculate if we should disable adding votes
const getMessagingEnabled = ( state: State) : boolean => !state.messaging.isDisabled

export default createSelector<State, any, WebcastStatusForVotes>(
  [
    getWebcastStatus,
    getLocalStatus,
    getMessagingEnabled
  ],
  (status, localStatus, messagingEnabled ) => isLocalHost() ? localStatus : combineStates( status, messagingEnabled)
)
